import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import ArchitectureIcon from "@mui/icons-material/Architecture";
import BuildIcon from "@mui/icons-material/Build";
import BusinessIcon from "@mui/icons-material/Business";
import ComputerRoundedIcon from "@mui/icons-material/ComputerRounded";
import CorporateFareIcon from "@mui/icons-material/CorporateFare";
import EngineeringIcon from "@mui/icons-material/Engineering";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import Shop2Icon from "@mui/icons-material/Shop2";
import StorefrontIcon from "@mui/icons-material/Storefront";
import WindPowerIcon from "@mui/icons-material/WindPower";

const iconSX = { height: "40px", width: "40px", color: "#FFFFFF" };

const ictIcon = () => {
    return <ComputerRoundedIcon sx={iconSX} />;
};

const marketingIcon = () => {
    return <StorefrontIcon sx={iconSX} />;
};

const repairIcon = () => {
    return <BuildIcon sx={iconSX} />;
};

const hrIcon = () => {
    return <PeopleAltIcon sx={iconSX} />;
};

const engineeringIcon = () => {
    return <EngineeringIcon sx={iconSX} />;
};

const serviceIcon = () => {
    return <ArchitectureIcon sx={iconSX} />;
};

const facilityIcon = () => {
    return <BusinessIcon sx={iconSX} />;
};

const feeIcon = () => {
    return <AccountBalanceIcon sx={iconSX} />;
};

const financeIcon = () => {
    return <AccountBalanceWalletIcon sx={iconSX} />;
};

const energyIcon = () => {
    return <WindPowerIcon sx={iconSX} />;
};

const corporateIcon = () => {
    return <CorporateFareIcon sx={iconSX} />;
};

const defaultIcon = () => {
    return <Shop2Icon sx={iconSX} />;
};

export const homepageIconDispatcher = {
    computer: ictIcon,
    corporate: corporateIcon,
    it: ictIcon,
    market: marketingIcon,
    repair: repairIcon,
    hr: hrIcon,
    material: engineeringIcon,
    engine: engineeringIcon,
    service: serviceIcon,
    facility: facilityIcon,
    fee: feeIcon,
    finance: financeIcon,
    energy: energyIcon,
    default: defaultIcon,
};
